import { IFAQ } from '@ecs/tng-common/src/interfaces';

export const returnOffersGroup = (result: any, group: string) => {
  const offers = result.offer_groups.filter((obj: any) => {
    return obj.type === group;
  });
  return offers[0];
};
export const modifyFAQstring = (str: string) => {
  const arr: IFAQ[] = [];
  const faqArr = str.split('~');
  faqArr.forEach((el: string, i: number) => {
    const elArr = el.split('|');
    const obj = {
      id: `${i}-faq`,
      heading: elArr[0] || '',
      content: elArr[1] || ''
    };
    arr.push(obj);
  });

  return arr;
};

export enum suppressionValues {
  powerReview = 'PowerReviews',
  public = 'Public',
  speedbump = 'PublicSpeedbump'
}
type SuppressedViewsType = string | string[];
export const ifSuppressedOffer = (
  suppressedViews: SuppressedViewsType,
  suppressionValue: string
) => {
  let arrOfValues: string[] = [];

  if (suppressedViews && typeof suppressedViews === 'string') {
    arrOfValues = suppressedViews.split(',');
  } else if (Array.isArray(suppressedViews)) {
    arrOfValues = suppressedViews;
  }

  return arrOfValues.includes(suppressionValue);
};
export const generateSessionId = () => {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    const r = Math.floor(Math.random() * 16);
    // eslint-disable-next-line prettier/prettier, no-bitwise
    const v = c === 'x' ? r : r & 0x3 || 0x8;
    return v.toString(16).toUpperCase();
  });
};
